module.exports = __webpack_public_path__ + "img/logo-installment-SCB.070ef9d7.png";